import { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Info, Text } from '@frontend/design-system';

type SummaryCardItemProps = {
  info?: string;
  label: string;
};

export const SummaryCardItem = ({ label, children, info, ...rest }: PropsWithChildren<SummaryCardItemProps>) => (
  <>
    <Text color='light' css={{ margin: 0 }} {...rest}>
      {label}
      {info && (
        <Info
          css={css`
            padding-left: ${theme.spacing(1)};
            color: ${theme.colors.neutral40};
          `}
          data-trackingid='pay-portal-invoices-btn-paymentsummaryhint'
        >
          {info}
        </Info>
      )}
      <br />
      {typeof children === 'string' ? (
        <Text
          color='default'
          weight='bold'
          as='span'
          css={css`
            margin-top: ${theme.spacing(1)};
          `}
        >
          {children}
        </Text>
      ) : (
        children
      )}
    </Text>
  </>
);
